<template>
  <div class="roomtype">
    <h2>{{ $t("roomType") }}</h2>
    <div class="flex">
      <div
        :class="
          roomtype.id == selectedRoomTypeId
            ? 'selected ' + requiredClassNames
            : requiredClassNames
        "
        v-for="roomtype in types"
        :key="roomtype.id"
        :id="roomtype.id"
        @click="selectRoomType(roomtype.id)"
      >
        <img :src="roomtype.imgSrc" :alt="$t('roomtypes.' + roomtype.id)" />
        <span>{{ $t("roomtypes." + roomtype.id) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    types: {
      type: Array,
      required: true
    },
    preselectedRoomType: {
      type: String,
      value: null
    }
  },
  data() {
    return {
      selectedRoomTypeId: this.preselectedRoomType,
      requiredClassNames: "flex__item roomtype__item"
    };
  },
  methods: {
    selectRoomType(roomId) {
      this.selectedRoomTypeId = roomId;
      this.$emit("select-roomtype", roomId);
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/include-media.scss";
@import "@/assets/scss/_variables.scss";
.flex {
  display: flex;
  justify-content: space-between;
  &__item {
    width: 18%;
  }
  @include media("<desktop-ml") {
    flex-wrap: wrap;
    justify-content: space-around;
    &__item {
      width: 33%;
    }
  }
  @include media("<phone-l") {
    &__item {
      width: 49%;
    }
  }
}
.roomtype {
  margin-bottom: 2em;
  &__item {
    position: relative;
    img {
      width: 100px;
      height: 200px;
      display: block;
      position: relative;
      z-index: 1;
      margin: 0 auto;
      opacity: 0.4;
    }
    span {
      position: absolute;
      bottom: 0;
      background-color: rgb(192, 192, 192);
      color: #000;
      display: block;
      width: 100%;
      z-index: 3;
      opacity: 0.7;
      padding: 1rem 0;
    }
    &.selected {
      // background-color: green;
      span {
        transition: all 0.4s;
        background-color: #000;
        color: white;
        opacity: 1;
      }
      img {
        opacity: 1;
      }
    }
    &:hover {
      span,
      img {
        opacity: 1;
        transition: all 0.4s;
      }
    }
  }
}
</style>
